module.exports = __webpack_public_path__ + "img/swift.02dd9f19.svg";